<template>
  <v-combobox
    class="input-field"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <template v-slot:append-item>
      <div v-if="lazy && isNextPage">
        <v-list-item class="pa-0 d-flex justify-center" v-intersect="loadMore">
          <div v-show="appending">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-list-item>
      </div>
    </template>
    <template #append>
      <slot name="append" />
    </template>
    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-combobox>
</template>

<script>
export class Pagination {
  //_state;
  constructor(itemPerPage = 20) {
    this._state = {
      page: 0,
      totalElements: 0,
      itemsPerPage: itemPerPage,
    };
  }
  nextPage() {
    if (this.isNextPage()) this._state.page++;
  }
  isNextPage() {
    return (
      this._state.page + 1 <
      Math.ceil(this._state.totalElements / this._state.itemsPerPage)
    );
  }
  setTotalElements(val) {
    this._state.totalElements = val;
  }
  resetPage() {
    this._state.page = 0;
  }
  getPage() {
    return this._state.page;
  }
  getItemsPerPage() {
    return this._state.itemsPerPage;
  }
}

export default {
  name: "TcnLazyCombobox",
  props: {
    lazy: {
      required: false,
      type: Boolean,
      default: false,
    },
    options: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      appending: false,
      currentPage: 0,
    };
  },
  computed: {
    isNextPage() {
      return this.options.isNextPage();
    },
  },
  methods: {
    loadMore(entries, observer, isIntersecting) {
      this.appending = isIntersecting;
      if (isIntersecting) {
        this.$emit("loadMoreRecords");
      }
    },
  },
};

// type PaginationOptions = {
//   page: number;
//   itemsPerPage: number;
//   totalElements: number;
// };
</script>

<style></style>
